import { store } from 'src/utils/store';

export const createClickHandler = (module: string) => () => {
    store.state.gaPush({
        event: 'ga4_event',
        event_name: 'retrofit_tool_assortment',
        retrofit_tool_assortment: {
            selected_assortment: module, //eg. Air or Sensors etc
            eventCategory: 'retrofit tool',
            eventAction: 'assortment',
            eventLabel: module //eg. Air or Sensors etc
        },
    });
}
